var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18198 1.69492C0.639266 2.26932 0.318359 3.16117 0.318359 4.31673V45.5895C0.318359 46.746 0.63936 47.6369 1.18198 48.2113L1.32008 48.3458L24.4403 25.2258V24.9532V24.6804L1.32008 1.55945L1.18198 1.69492Z",
    fill: "url(#paint0_linear_3784_85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1467 32.9359L24.4404 25.2259V24.9533V24.6804L32.1485 16.9724L32.3222 17.0715L41.4531 22.2597C44.0613 23.7414 44.0613 26.166 41.4531 27.6487L32.3222 32.8369L32.1467 32.9359Z",
    fill: "url(#paint1_linear_3784_85)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3218 32.8357L24.4399 24.9531L1.18164 48.2112C2.04161 49.1213 3.46061 49.234 5.0598 48.3258L32.3218 32.8357Z",
    fill: "url(#paint2_linear_3784_85)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3218 17.0703L5.0598 1.58027C3.46061 0.672018 2.04161 0.784705 1.18164 1.69483L24.4399 24.9531L32.3218 17.0703Z",
    fill: "url(#paint3_linear_3784_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3784_85",
    x1: 22.39,
    y1: 3.88157,
    x2: -8.92911,
    y2: 35.2006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3784_85",
    x1: 44.849,
    y1: 24.9541,
    x2: -0.306878,
    y2: 24.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3784_85",
    x1: 28.039,
    y1: 29.2362,
    x2: -14.4322,
    y2: 71.7074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30864"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3784_85",
    x1: -4.67456,
    y1: -12.0437,
    x2: 14.2906,
    y2: 6.9215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#00A86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#00CF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#00E76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EF6D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.9327459e46bd08a8d716519095c40c02.svg";
export { ForwardRef as ReactComponent };